export default __webpack_public_path__ + "static/media/RCSP_ENTERPRISE.07084314.svg";